import { EMPTY, Observable, of } from 'rxjs'
import { debounce, delay, map, mergeMap, startWith, switchMap, take, tap } from 'rxjs/operators'
import { combineEpics, ofType, StateObservable } from 'redux-observable'
import { ClientActionTypes, ClientLoginAction, HeartbeatAction, ServerMessageType } from 'api'
import { GlobalState } from 'store'
import { ConnectionDependencies } from './connectionEpic'
import { TimeActions } from 'store/time'
import { DiagnosticsDependencies } from './diagnosticsEpic'
import { RepositoryActions } from 'store/repository'
import { heartbeatTimeoutSelector } from 'selectors/configurationSelectors'
import { createAction } from 'utils'
import { ConnectionActions } from 'store/connection'
import { BTQAction } from 'epics'

export function heartbeatTimestampEpic(
  action$: Observable<BTQAction>,
  _state$: Observable<GlobalState>,
  _dependencies: ConnectionDependencies
): Observable<BTQAction> {
  return action$.pipe(
    ofType<BTQAction, ServerMessageType.HEARTBEAT, HeartbeatAction>(ServerMessageType.HEARTBEAT),
    map(action => {
      return TimeActions.setTimes(action.payload.now, new Date().toISOString())
    })
  )
}

export function missedHeartbeatEpic(
  action$: Observable<BTQAction>,
  state$: StateObservable<GlobalState>,
  dependencies: ConnectionDependencies & DiagnosticsDependencies
): Observable<BTQAction> {
  return action$.pipe(
    ofType<BTQAction, ClientActionTypes.LOGIN_MESSAGE, ClientLoginAction>(ClientActionTypes.LOGIN_MESSAGE),
    switchMap(() =>
      action$.pipe(
        startWith(createAction(ServerMessageType.HEARTBEAT)),
        ofType(ServerMessageType.HEARTBEAT),
        mergeMap(() => {
          const timeoutMS = heartbeatTimeoutSelector(state$.value)
          return timeoutMS > 0 ? of(timeoutMS) : EMPTY
        }),
        debounce(timeoutMS => delay(timeoutMS)(of(timeoutMS))),
        take<number>(1),
        tap(timeout => {
          dependencies.diagnosticsLogger.log(
            `${new Date().toISOString()} No heartbeat has been received in the last ${timeout /
              1000} seconds, clearing repositories and re-connecting`
          )
        }),
        mergeMap(() => of(RepositoryActions.repositoryReset(), ConnectionActions.forceDisconnect()))
      )
    )
  )
}

export const heartbeatEpic = combineEpics(heartbeatTimestampEpic, missedHeartbeatEpic)
